import React from 'react';
import {EyeIcon, LockIcon, ShieldIcon, UsersIcon} from '../icons';
import {SECURITY_BLOCK} from './content';

const SECURITY_ICONS: Record<string, React.FC<{className?: string}>> = {
    encryption: LockIcon,
    ownership: UsersIcon,
    'third-party': ShieldIcon,
    policy: EyeIcon,
};

/**
 * Секция «Безопасность» — тёмная полоса во всю ширину.
 *
 * Раньше это была одна из трёх одинаковых карточек в ряду, и разговор о доверии
 * звучал ровно так же, как виджет со статистикой. Здесь он получает собственную
 * плотность и единственный на странице разворот к тёмному фону: смена
 * материала — самый сильный способ сказать «остановитесь и прочитайте».
 * Полоса тёмная в обеих темах намеренно.
 */
const SecurityBand: React.FC = () => (
    <section id="security" className="scroll-mt-20" aria-labelledby="landing-security-title">
        <div className="rounded-3xl bg-ink-900 dark:bg-ink-900 border border-white/5 px-6 sm:px-10 py-10 sm:py-14">
            <div className="grid lg:grid-cols-[1fr_1.4fr] gap-10 lg:gap-14">
                <div className="min-w-0">
                    <h2
                        id="landing-security-title"
                        className="text-3xl sm:text-4xl font-bold leading-[1.06] tracking-[-0.03em] text-ink-50 text-balance"
                    >
                        {SECURITY_BLOCK.titleLead}{' '}
                        <span className="text-brand-400">{SECURITY_BLOCK.titleAccent}</span>
                    </h2>
                    <p className="mt-5 text-base leading-7 text-ink-300 max-w-[42ch]">{SECURITY_BLOCK.text}</p>
                </div>

                <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-8 min-w-0">
                    {SECURITY_BLOCK.points.map(point => {
                        const Icon = SECURITY_ICONS[point.id];
                        return (
                            <li key={point.id} className="min-w-0">
                                <Icon className="w-5 h-5 text-brand-400"/>
                                <h3 className="mt-3 text-sm font-semibold text-ink-50">{point.title}</h3>
                                <p className="mt-1.5 text-sm leading-6 text-ink-300">{point.text}</p>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    </section>
);

export default SecurityBand;
